import graphql from "babel-plugin-relay/macro";

export const QUERY = graphql`
    query searchNodesCarouselComponent_Query(
        $query: String
        $tagIds: [ID!]
        $elementTypes: [ElementTypeV2!]
    ) {
        ...searchNodesCarouselComponent_NodeFragment
        @arguments(query: $query, tagIds: $tagIds, elementTypes: $elementTypes)
    }
`;

export const FRAGMENT = graphql`
    fragment searchNodesCarouselComponent_NodeFragment on Query
    @refetchable(queryName: "searchNodesCarouselComponent_Refetch")
    @argumentDefinitions(
        first: { type: "Int", defaultValue: 10 }
        after: { type: "String" }
        query: { type: "String" }
        tagIds: { type: "[ID!]" }
        elementTypes: { type: "[ElementTypeV2!]" }
    ) {
        LearnV2 {
            NodesSearchResult(
                first: $first
                after: $after
                query: $query
                tagIds: $tagIds
                elementTypes: $elementTypes
            ) @connection(key: "searchNodesCarouselComponent_NodesSearchResult") {
                pageInfo {
                    endCursor
                    hasPreviousPage
                    hasNextPage
                    startCursor
                }
                edges {
                    node {
                        ...UseNodeLogic_NodeFragment
                    }
                    cursor
                }
            }
        }
    }
`;
